// extracted by mini-css-extract-plugin
export var contacts = "contactsContainer-module--contacts--1gFKI";
export var textWrap = "contactsContainer-module--textWrap--3RH8P";
export var title = "contactsContainer-module--title--RAwv3";
export var subtitle = "contactsContainer-module--subtitle--1d5JG";
export var list = "contactsContainer-module--list--26tmB";
export var delimiter = "contactsContainer-module--delimiter--344bi";